import React, { useState, useEffect, useContext } from "react";
import "./Footer.css";
import { NavLink } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebookF,
  faInstagram,
  faLinkedinIn,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FooterData } from "../../utils/apis/footer/Footer";
import { IDS } from "../../utils/common";
import { Context } from "../../utils/context";
import { Services } from "../../utils/apis/service/Service";
import { faAnglesRight } from "@fortawesome/free-solid-svg-icons";

const Footer = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { IMG_URL } = useContext(Context);

  const [appsetup, setAppSetup] = useState({});
  const [services, setServices] = useState([]);

  var HtmlToReactParser = require("html-to-react").Parser;
  var htmlToReactParser = new HtmlToReactParser();

  const getAppSetup = async () => {
    const res = await FooterData();
    if (res?.success) {
      setAppSetup(res?.data?.[0] || {});
    }
  };

  const getService = async () => {
    const res = await Services();
    if (res?.success) {
      setServices(res?.data?.data || []);
    }
  };

  useEffect(() => {
    getAppSetup();
    getService();
  }, []);

  const handleNavClick = (path, e) => {
    e.preventDefault();

    if (location.pathname === path) {
      window.scrollTo({ top: 0, behavior: "auto" });
    } else {
      navigate(path);
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: "auto" });
      }, 200);
    }
  };

  return (
    <>
      <footer className="Footer two_section_holder">
        <div className="custom_container">
          <div className="footer_holder">
            <div className="row mb-4 me-0 ms-0">
              {/* LOGO + ADDRESS */}
              <div className="col-lg-3 col-md-4 mb-4">
                <div className="logo_holder">
                  <Link as={Link} to={"/"}>
                    <img
                      src={IDS?.IMG_URL + appsetup?.logo}
                      alt="Logo"
                      className="logo_img"
                    />
                  </Link>
                </div>

                <div className="logo_text_holder">
                  <p className="logo_text">
                    <span className="address d-block">{appsetup.address}</span>
                  </p>
                </div>
              </div>

              {/* SERVICES */}

              {/* QUICK LINKS (UPDATED 2 COLUMN) */}
              <div className="col-lg-3 col-md-4 col-sm-6 col-6 mb-4 col_div">
                <h5 className="footer_section_title">
                  <FontAwesomeIcon icon={faAnglesRight} /> QUICK LINKS
                </h5>

                <div className="quick_links two_column_links">
                  <div>
                    <NavLink as={Link} to="/" className="quick_text">
                      Home
                    </NavLink>
                    <NavLink as={Link} to="/blog" className="quick_text">
                      Blog
                    </NavLink>
                    <NavLink
                      as={Link}
                      to="/explore-produtcs"
                      className="quick_text"
                    >
                      Explore Products
                    </NavLink>
                    <NavLink as={Link} to="/about-us" className="quick_text">
                      About Us
                    </NavLink>
                    <NavLink as={Link} to="/gallery" className="quick_text">
                      Gallery
                    </NavLink>
                  </div>
                </div>
              </div>

              <div className="col-lg-3 col-md-4 col-sm-6 col-6 mb-4 col_div">
                <div className="quick_links two_column_links">
                  <div>
                    <NavLink as={Link} to="/contact-us" className="quick_text">
                      Contact Us
                    </NavLink>
                    <NavLink
                      as={Link}
                      to="/terms-of-services"
                      className="quick_text"
                    >
                      Terms & Conditions
                    </NavLink>
                    <NavLink
                      as={Link}
                      to="/privacy-policy"
                      className="quick_text"
                    >
                      Privacy Policy
                    </NavLink>
                  </div>
                </div>
              </div>

              {/* CONTACT */}
              <div className="col-lg-3 col-sm-6 col-12 col-md-4 col_div">
                <h5 className="footer_section_title">
                  {" "}
                  <FontAwesomeIcon icon={faAnglesRight} /> FOLLOW ON
                </h5>

                <div className="footer_icon_holder">
                  <div className="footer_links">
                    {[
                      { icon: faFacebookF, link: "https://www.facebook.com/" },
                      { icon: faInstagram, link: "https://www.instagram.com/" },
                      { icon: faLinkedinIn, link: "https://www.linkedin.com/" },
                      { icon: faYoutube, link: "https://www.youtube.com/" },
                    ].map((item, index) => (
                      <a
                        key={index}
                        href={item.link}
                        className="footer_link"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <div className="icon_holder">
                          <FontAwesomeIcon icon={item.icon} />
                        </div>
                      </a>
                    ))}
                  </div>
                </div>
              </div>
            </div>
            {/* BOTTOM */}
            <div className="footer_text_div_holder">
              <div className="footer_text_div">
                <p className="footer_text">
                  Copyright ©2026 All Rights Reserved. Developed by{" "}
                  <a
                    href="https://profcymaglobal.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="link_text"
                  >
                    Profcyma
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
